const gNum = {};
/** 浮点数加减乘除 */
gNum.multi = (a, b) => {
    let c = 0;
    const d = a.toString();
    const e = b.toString();
    try { c += d.split('.')[1].length; } catch (f) { c += 0; }
    try { c += e.split('.')[1].length; } catch (f) { c += 0; }
    return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / (10 ** c);
};
gNum.divide = (a, b) => {
    let e = 0;
    let f = 0;
    try { e = a.toString().split('.')[1].length; } catch (g) { e = 0; }
    try { f = b.toString().split('.')[1].length; } catch (g) { f = 0; }
    const c = Number(a.toString().replace('.', ''));
    const d = Number(b.toString().replace('.', ''));
    return gNum.multi(c / d, (10 ** (f - e)));
};
gNum.add = (a, b) => {
    let c;
    let d;
    try { c = a.toString().split('.')[1].length; } catch (f) { c = 0; }
    try { d = b.toString().split('.')[1].length; } catch (f) { d = 0; }
    const e = 10 ** Math.max(c, d);
    return (gNum.multi(a, e) + gNum.multi(b, e)) / e;
};
gNum.minus = (a, b) => {
    let c;
    let d;
    try { c = a.toString().split('.')[1].length; } catch (f) { c = 0; }
    try { d = b.toString().split('.')[1].length; } catch (f) { d = 0; }
    const e = 10 ** Math.max(c, d);
    return (gNum.multi(a, e) - gNum.multi(b, e)) / e;
};
gNum.higher = (a) => {
    if (a < 0) {
        return 0;
    }
    if (a === 0 || a === Infinity) {
        return 1;
    }
    const removeBit = 10 ** Math.floor(Math.log10(a));
    return Math.ceil(a / removeBit) * removeBit;
};
gNum.numberToMoney = (number, f) => {
    if (!Number.isNaN(+number)) {
        let moneyNumber = +number;
        const fBit = f >= 0 && f <= 10 ? f : 2;
        moneyNumber = parseFloat(moneyNumber.toString().replace(/[^\d.-]/g, '')).toFixed(fBit);
        const intArea = moneyNumber.split('.')[0].split('').reverse();
        let floatArea = moneyNumber.split('.')[1];
        let money = '';
        for (let i = 0; i < intArea.length; i += 1) {
            money += intArea[i] + ((i + 1) % 3 === 0 && (i + 1) !== intArea.length && intArea[i + 1] !== '-' ? ',' : '');
        }
        floatArea = floatArea ? `.${floatArea}` : '';
        return money.split('').reverse().join('') + floatArea;
    }
    if (typeof number === 'undefined' || Number.isNaN(number)) {
        return '';
    }
    return number.toString();
};
gNum.moneyToNumber = (money) => {
    if (money !== 0 && !money) {
        return NaN;
    }
    const number = parseFloat((`${money}`).replace(/[^\d.-]/g, ''));
    return +number;
};
gNum.toPercent = (number, f) => {
    let percentNumber = +number;
    const fBit = f >= 0 && f <= 10 ? f : 2;
    percentNumber = (percentNumber * 100).toFixed(fBit);
    return percentNumber;
};
gNum.fromPercent = (percent, f) => {
    f = f >= 0 && f <= 10 ? f : 4;
    return gNum.divide(gNum.moneyToNumber(percent), 100).toFixed(f);
};
gNum.numberToWan = (number, f) => {
    if (!Number.isNaN(+number)) {
        return gNum.numberToMoney(+number / 10000, f);
    }
    if (typeof number === 'undefined') {
        return '';
    }
    return number.toString();
};
gNum.numberToWanDetail = (number, f) => {
    if (!Number.isNaN(+number)) {
        if (+number < 999) {
            return gNum.numberToMoney(+number, f);
        }
        return `${gNum.toWan(+number, f)}万`;
    }
    if (typeof number === 'undefined') {
        return '';
    }
    return number.toString();
};
gNum.toWan = (number, f) => {
    const wan = gNum.numberToWan(number, f);
    if (wan && typeof wan === 'string' && wan.indexOf('.') !== -1) {
        return wan.replace(/(\.?0*)$/, '');
    }
    return wan.toString();
};

export default gNum;
